import { inject } from "@angular/core";
import { Router } from "@angular/router";

import { RootStore } from "../store/root.store";

export const loginGuard = async () => {
  const rootStore = inject(RootStore);
  const router = inject(Router);

  if (rootStore.userStore.getAuthToken()) {
    router.navigate(["/"]);
    return false;
  } else {
    return true;
  }
};
